// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"D","header":"E","confirmHeader":"F","title":"G","description":"H","subHeader":"I","button":"J"};